import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDossier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconDossier"><Path d="M2 6.75C2 5.23122 3.23122 4 4.75 4H8V9.5H22V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75Z" fill="currentColor"/><Path d="M9.5 4H15V8H9.5V4Z" fill="currentColor"/><Path d="M16.5 4H19.25C20.7688 4 22 5.23122 22 6.75V8H16.5V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDossier;
